/**
 * @fileoverview GET handler for the "/engagement/in_app_message_color_profiles/default" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInAppMessageColorProfilesDefault } from "./constants";
import type { EngagementInAppMessageColorProfilesDefaultResult } from "./types";

export const getEngagementInAppMessageColorProfilesDefault = reactQueryFetcherAdapter(
  engagementInAppMessageColorProfilesDefault,
  (signal: AbortSignal): Promise<EngagementInAppMessageColorProfilesDefaultResult> => {
    return fetch("/engagement/in_app_message_color_profiles/default", "GET", {}, { signal });
  }
);
